import createReactComponent from '../createReactComponent';
var Binary = createReactComponent('Binary', [['path', {
  d: 'M10 4H6v6h4V4z',
  key: '7fv97c'
}], ['path', {
  d: 'M18 14h-4v6h4v-6z',
  key: 'p975cx'
}], ['path', {
  d: 'M14 4h2v6m-2 0h4',
  key: 'ltejvm'
}], ['path', {
  d: 'M6 14h2v6m-2 0h4',
  key: 'oct1eo'
}]]);
export default Binary;